// Catelan Joias — interações base do tema
document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initCartDrawer();
  initProductGallery();
  initQuantitySelectors();
  initVariantPickers();
  initHeroCarousel();
  initTestimonialsCarousel();
  initCookieBanner();
  initAnnouncementBar();
});

function initProductGallery() {
  var mainImage = document.getElementById('ProductMainImage');
  if (!mainImage) return;

  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var fullSrc = thumb.getAttribute('data-full-src');
      if (!fullSrc) return;

      mainImage.src = fullSrc;
      mainImage.alt = thumb.alt;
    });
  });
}

function initTestimonialsCarousel() {
  document.querySelectorAll('[data-testimonials-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-testimonials-track]');
    var slides = carousel.querySelectorAll('.testimonials-carousel__slide');
    var dotsWrap = carousel.querySelector('[data-testimonials-dots]');
    var prevBtn = carousel.querySelector('[data-testimonials-prev]');
    var nextBtn = carousel.querySelector('[data-testimonials-next]');
    var perPage = parseInt(carousel.dataset.perPage, 10) || 3;
    if (!track || !slides.length) return;

    function getPerPage() {
      return window.innerWidth <= 900 ? 1 : perPage;
    }

    var maxIndex = Math.max(0, slides.length - getPerPage());
    var current = 0;

    function buildDots() {
      dotsWrap.textContent = '';
      for (var i = 0; i <= maxIndex; i++) {
        var dot = document.createElement('button');
        dot.className = 'testimonials-carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () { goTo(index); });
        })(i);
        dotsWrap.appendChild(dot);
      }
    }
    buildDots();

    function goTo(index) {
      current = Math.max(0, Math.min(index, maxIndex));
      var slideWidth = slides[0].getBoundingClientRect().width + 32;
      track.style.transform = 'translateX(-' + (current * slideWidth) + 'px)';
      var dots = dotsWrap.querySelectorAll('.testimonials-carousel__dot');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    window.addEventListener('resize', function () {
      maxIndex = Math.max(0, slides.length - getPerPage());
      buildDots();
      goTo(Math.min(current, maxIndex));
    });
  });
}

function initHeroCarousel() {
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('.hero-carousel__slide');
    var dots = carousel.querySelectorAll('[data-hero-carousel-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var intervalMs = (parseFloat(carousel.dataset.autoplay) || 5) * 1000;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    var timer = setInterval(function () {
      goTo((current + 1) % slides.length);
    }, intervalMs);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(i);
        timer = setInterval(function () {
          goTo((current + 1) % slides.length);
        }, intervalMs);
      });
    });
  });
}

function initMobileMenu() {
  var burger = document.querySelector('[data-mobile-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (!burger || !menu) return;

  burger.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', isOpen);
  });

  document.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('.site-nav__item');
      if (!item) return;
      var isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  });

  document.querySelectorAll('[data-submenu-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (window.matchMedia('(max-width: 900px)').matches) {
        event.preventDefault();
        var item = link.closest('.site-nav__item');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        var toggle = item.querySelector('[data-submenu-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', isOpen);
      }
    });
  });
}

function initCartDrawer() {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-drawer-overlay]');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-product-form]')) return;

    event.preventDefault();
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro ao adicionar ao carrinho');
        return response.json();
      })
      .then(function () {
        return refreshCartDrawer();
      })
      .then(function () {
        openDrawer();
      })
      .catch(function (error) {
        console.error(error);
      });
  });

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('[data-cart-remove]');
    if (!removeBtn) return;

    event.preventDefault();
    var key = removeBtn.getAttribute('data-cart-remove');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () {
        return refreshCartDrawer();
      })
      .catch(function (error) {
        console.error(error);
      });
  });
}

function refreshCartDrawer() {
  return fetch('/cart?section_id=cart-drawer')
    .then(function (response) {
      if (!response.ok) throw new Error('Erro ao atualizar carrinho');
      return response.text();
    })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.querySelector('[data-cart-drawer-content]');
      var currentDrawer = document.querySelector('[data-cart-drawer-content]');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      var newCount = doc.querySelector('[data-cart-count]');
      var currentCount = document.querySelector('[data-cart-count]');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }
    });
}

function initQuantitySelectors() {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-change]');
    if (!button) return;

    var wrapper = button.closest('[data-quantity-wrapper]');
    var input = wrapper.querySelector('input[type="number"]');
    var step = parseInt(button.getAttribute('data-quantity-change'), 10);
    var newValue = Math.max(1, parseInt(input.value || '1', 10) + step);
    input.value = newValue;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function initVariantPickers() {
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    picker.addEventListener('change', function () {
      var form = picker.closest('form');
      if (!form) return;

      var groups = Array.from(form.querySelectorAll('[data-variant-picker]'));
      var selectedOptions = groups.map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked') || group.querySelector('[data-variant-option]');
        return checked ? checked.value : null;
      }).filter(function (v) { return v !== null; });

      var variantsJson = form.querySelector('[data-product-variants]');
      if (!variantsJson) return;

      var variants = JSON.parse(variantsJson.textContent);
      var match = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });
      });

      var idInput = form.querySelector('input[name="id"]');
      var priceEl = document.querySelector('[data-product-price]');
      var addButton = form.querySelector('[data-add-to-cart]');

      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (addButton) {
          addButton.disabled = !match.available;
          addButton.textContent = match.available
            ? addButton.getAttribute('data-label-available')
            : addButton.getAttribute('data-label-unavailable');
        }

        // Atualiza rótulo de cor selecionada
        groups.forEach(function (group) {
          var valueEl = group.querySelector('[data-variant-value]');
          var checked = group.querySelector('input[type="radio"]:checked');
          if (valueEl && checked) {
            valueEl.textContent = checked.value;
          }
        });
      }
    });
  });
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function initAnnouncementBar() {
  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  if (sessionStorage.getItem('announcementDismissed') === '1') {
    bar.hidden = true;
    return;
  }

  bar.querySelectorAll('[data-announcement-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      bar.hidden = true;
      sessionStorage.setItem('announcementDismissed', '1');
    });
  });
}

function initCookieBanner() {
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;

  var accepted = localStorage.getItem('cookieConsent');
  if (accepted === 'accepted' || accepted === 'rejected') {
    banner.remove();
    return;
  }

  banner.classList.add('is-visible');

  banner.querySelectorAll('[data-cookie-accept]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      localStorage.setItem('cookieConsent', 'accepted');
      banner.classList.remove('is-visible');
      setTimeout(function () { banner.remove(); }, 300);
    });
  });

  banner.querySelectorAll('[data-cookie-reject]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      localStorage.setItem('cookieConsent', 'rejected');
      banner.classList.remove('is-visible');
      setTimeout(function () { banner.remove(); }, 300);
    });
  });
}
